module.exports = __webpack_public_path__ + "img/list-pattern2.2b9a623.svg";